module.exports = __webpack_public_path__ + "img/sideHelp1.e7f9dbe1.svg";